import React, { useEffect, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import Configuration from "../../../configuration";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { grossisteAdded, grossisteGetById } from "../../../Redux/grossisteReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";

function AjouterGrossiste({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  var annee = localStorage.getItem("annee");
  var id = 0
  if (isNaN(location.id) === true) document.title = t("Grossiste.add");
  else {
    id = location.id;
    document.title = t("Grossiste.update");
  }
  const [quota, setQuota] = React.useState(null);
  const [seuil, setSeuil] = React.useState(null);
  const saveCalled = useRef(false);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }


  function submitForm(event) {
    if (quota != null) {
      if (saveCalled.current) return;
      saveCalled.current = true;
      dispatch(
        grossisteAdded({
          quota: quota,seuil,
          id,client
        })
      )
        .then((e) => {
          if (e.payload == true) {
            notify(1, t("add_txt"));
            setTimeout(async () => {
              navigate.push(client + "/listGrossiste");
            }, 800);
          } else {
            notify(2, t("problem"));
            saveCalled.current = false;
          }
        })
        .catch((error) => {
          notify(2, t("erreur_add"));
          saveCalled.current = false;
          console.error("Error updating grossiste:", error);
        });

    } else {
      notify(2, t("erreur_add"));
    }


  }


  useEffect(() => {
    async function getGrossiste() {
      if (isNaN(location.id) === false) {
        var grossiste = await dispatch(grossisteGetById(location.id));
        var entities = grossiste.payload;
        if (entities === false) {
          navigate.push(client + '/listGrossiste');
        }
        else {
          setQuota(client == "/medis" ? entities.quota_indestrie2 : entities.quota_indestrie3);
          setSeuil(client == "/medis" ? entities.seuil_indestrie2 : entities.seuil_indestrie3);
        }
      }
    }
    getGrossiste();
  }, [location.id, dispatch, navigate]);

  function listeGrossiste() {
    navigate.push(client + '/listGrossiste');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeGrossiste}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('Grossiste.add')
                        : t('Grossiste.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label> Quota * </label>
                          <Form.Control
                            value={quota}
                            placeholder={"Quota"}
                            type="number"
                            onChange={(value) => {
                              setQuota(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>Couverture Cible* </label>
                          <Form.Control
                            value={seuil}
                            placeholder={"Seuil"}
                            type="number"
                            onChange={(value) => {
                              setSeuil(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container >
    </>
  );
}

export default AjouterGrossiste;
